import { useEffect } from 'react';
import Router from './Router/router';
import './App.css';
import DataProvider from './Contexts/DataProvider';
import { ProvideAuth, useAuth } from './Contexts/AuthContext';
import { SimulationProvider } from './Contexts/SimulationContext';
import { KnowledgebaseProvider } from './Contexts/KnowledgebaseContext';
import { ThemeProvider } from '@mui/material/styles';
import { theme } from './Contexts/ThemeContext';
import 'ag-grid-community/styles/ag-grid.css'; // Core grid CSS, always needed
import 'ag-grid-community/styles/ag-theme-alpine.css'; // Optional theme CSS
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import { LicenseManager } from 'ag-grid-enterprise';
import { setupConsoleCapture } from './Helpers/supportContact';
import DebugPanel from './Components/DebugPanel/DebugPanel.jsx';
import KnowledgebasePanel from './Components/Knowledgebase/KnowledgebasePanel.jsx';
import AppErrorBoundary from './Components/AppErrorBoundary/AppErrorBoundary.jsx';

// Set AG Grid license globally for all grid instances using a build-time env variable
const agGridLicenseKey = import.meta.env.VITE_AG_GRID_LICENSE_KEY;
if (agGridLicenseKey) {
  LicenseManager.setLicenseKey(agGridLicenseKey);
}

// Wrapper component to access auth context for SimulationProvider
const AppContent = () => {
  const auth = useAuth();
  
  // Initialize console capture for error reporting
  useEffect(() => {
    setupConsoleCapture();
  }, []);
  
  return (
    <KnowledgebaseProvider>
      <DataProvider>
        <SimulationProvider activeUser={auth.activeUser}>
          <ToastContainer />
          <Router />
          <KnowledgebasePanel />
          <DebugPanel />
        </SimulationProvider>
      </DataProvider>
    </KnowledgebaseProvider>
  );
};

const App = () => {
  // Remove the FOUC guard class once React has mounted and styles are injected.
  // This prevents the brief flash of unstyled/raw content on initial load.
  useEffect(() => {
    document.getElementById('root')?.classList.add('app-ready');
  }, []);

  return (
    <div className="App">
      <AppErrorBoundary>
        <ProvideAuth>
          <AppContent />
        </ProvideAuth>
      </AppErrorBoundary>
    </div>
  );
};

export default App;
